import { ref, computed } from 'vue'
import { type ResType } from '@api-client/typeUtils';
import { storeOrdersApiClient } from '@api-client/store_orders';
import { MySettingsStore, addListeningStore } from './MySettingsStore';
import { listenStoreNotifier } from './listenStoreNotifier';
import { authState, waitUntilReady } from '@api-client/auth/auth';

export type storeListType = ResType<
    typeof storeOrdersApiClient.my_order_stores.$post
>["data"];

export const myStores = ref<storeListType>([]);
export const isMyStoresLoading = ref(true);

export const searchQuery = ref('')
export const myStoresFiltered = computed(() =>
    myStores.value.filter(store =>
        store.name?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        store.address1?.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
)

export const storesWithNegativeBalance = computed(() => myStores.value.filter(store => store.hasNegativeBalance))

export async function loadMyStores() {
    isMyStoresLoading.value = true;
    const response = await (await storeOrdersApiClient.my_order_stores.$post()).json()
    if (response.error) {
        console.error(response.error)
        return
    } else {
        myStores.value = response.data.sort((
            a,
            // _b
        ) => {
            return MySettingsStore.value[a.id]?.isEnabled ? -1 : 1;
        });

        // Check if no stores are enabled but stores exist, then enable the first one
        const hasEnabledStores = myStores.value.some(store =>
            MySettingsStore.value[store.id]?.isEnabled
        );

        if (!hasEnabledStores && myStores.value.length > 0) {
            addListeningStore(myStores.value[0].id);
        }

        for (const store of myStores.value) {
            if (MySettingsStore.value[store.id]?.isEnabled) {
                listenStoreNotifier(store.id);
            }
        }
    }
    isMyStoresLoading.value = false;
}


waitUntilReady.then(() => {
    loadMyStores();
});

authState.subscribe(() => {
    loadMyStores();
});